<script>
import {addUser} from "@/api/accounts.js";
import {required, minLength, maxLength, alphaNum, email, sameAs} from "vuelidate/lib/validators";
import swal from "sweetalert";

export default {
  name: "add-user-modal",
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        email: null,
        company_name: null,
        phone_number: null,
        password: null,
        confirm_password: null,
      },

    };
  },
  validations: {
    form: {
      first_name: {
        alphaNum,
        maxLength: maxLength(255),
        minLength: minLength(2)
      },
      last_name: {
        alphaNum,
        maxLength: maxLength(255),
        minLength: minLength(2)
      },
      company_name: {
        required,
        maxLength: maxLength(255),
        minLength: minLength(2)
      },
      email: {
        required,
        email,
      },
      phone_number: {
        required,
        maxLength: maxLength(16),
        minLength: minLength(10)
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirm_password: {
        sameAsPassword: sameAs('password'),
      },

    },

  },
  methods: {
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        swal("Invalid", "Please fill in the accurate information");
      } else {

        const payload = JSON.parse(JSON.stringify(this.form));
        const response = await addUser(payload);
        if (response && response.success) {
          swal("New user", "Successfully added");
          this.form.first_name = null;
          this.form.last_name = null;
          this.form.email = null;
          this.form.company_name = null;
          this.form.phone_number = null;
          this.form.password = null;
          this.confim_password = null;
          setTimeout(() => {
            this.$store.dispatch("getUsers");
            this.$refs["modal-add-user"].hide();
          }, 1000);
        }
      }
    }
  }
};
</script>

<template>
  <b-modal
      id="modal-add-user"
      ref="modal-add-user"
      title="Add user"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
  >
    <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
        id="form-modal-add-user"
    >
      <b-form-group label="First Name" :class="{ 'form-group--error': $v.form.first_name.$error }">
        <b-form-input v-model.trim="$v.form.first_name.$model" required></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.first_name.minLength">Field must have at least
            {{ $v.form.first_name.$params.minLength.min }} letters</span>
          <span class="d-block p-1" v-if="!$v.form.first_name.alphaNum">No Symbols allowed</span>
        </p>
      </b-form-group>

      <b-form-group label="Last Name" :class="{ 'form-group--error': $v.form.last_name.$error }">
        <b-form-input v-model.trim="$v.form.last_name.$model" ></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.last_name.minLength">Field must have at least
            {{ $v.form.last_name.$params.minLength.min }} letters</span>
          <span class="d-block p-1" v-if="!$v.form.last_name.alphaNum">No Symbols allowed</span>
        </p>
      </b-form-group>

      <b-form-group label="Email" :class="{ 'form-group--error': $v.form.email.$error }">
        <b-form-input v-model.trim="$v.form.email.$model" type="email" ></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.email.required">Field is required</span>
          <span class="d-block p-1" v-if="!$v.form.email.email">Please enter a valid email</span>
        </p>


      </b-form-group>
      <b-form-group label="Phone Number" :class="{ 'form-group--error': $v.form.phone_number.$error }">
        <b-form-input v-model.trim="$v.form.phone_number.$model" type="tel" ></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.phone_number.required">Field is required</span>
          <span class="d-block p-1" v-if="!$v.form.phone_number.minLength ">Please enter a valid Phone Number</span>
        </p>
      </b-form-group>
      <b-form-group label="Company Name" :class="{ 'form-group--error': $v.form.company_name.$error }">
        <b-form-input v-model.trim="$v.form.company_name.$model" required></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.company_name.minLength">Field must have at least
            {{ $v.form.company_name.$params.minLength.min }} letters</span>
        </p>
      </b-form-group>
      <b-form-group label="Password" :class="{ 'form-group--error': $v.form.password.$error }">
        <b-form-input v-model.trim="$v.form.password.$model" type="password" required></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.password.required">Field is required</span>
          <span class="d-block p-1" v-if="!$v.form.password.minLength">Password must have at least
            {{ $v.form.password.$params.minLength.min }} characters</span>
        </p>
      </b-form-group>
      <b-form-group label="Confirm password" :class="{ 'form-group--error': $v.form.confirm_password.$error}">
        <b-form-input v-model.trim="$v.form.confirm_password.$model" type="password" required></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.confirm_password.sameAsPassword">Passwords do not match
            </span>
        </p>
      </b-form-group>
      <b-button type="submit" class="float-right" variant="primary">
        Add
      </b-button>
    </b-form>
  </b-modal>
</template>
